module.exports = __webpack_public_path__ + "static/media/scooter-pin.927652d6.svg";